// extracted by mini-css-extract-plugin
export default {"histogram-range":"histogram-range_histogram-range__bu-z3","range":"histogram-range_range__C3JV-","form":"histogram-range_form__gM4jb","field":"histogram-range_field__rPI2O"};